// Copyright © 2020 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export default Object.freeze({
  GATEWAY_EUI: 'gateway-eui',
  FREQUENCY_PLAN: 'frequency-plan',
  ACTIVATION_MODE: 'activation-mode',
  LORAWAN_VERSION: 'lorawan-version',
  JOIN_SERVER: 'join-server',
  APP_EUI: 'appeui',
  JOIN_EUI: 'joineui',
  DEV_EUI: 'deveui',
  APP_KEY: 'appkey',
  REGIONAL_PARAMETERS: 'regional-parameters',
  CLASS_C: 'class-c',
  NETWORK_SESSION_KEY: 'network-session-key',
  FORWARDING_NETWORK_SESSION_INTEGRITY_KEY: 'forwarding-network-session-integrity-key',
  SERVING_NETWORK_SESSION_INTEGRITY_KEY: 'serving-network-session-integrity-key',
  NETWORK_SESSION_ENCRYPTION_KEY: 'network-session-encryption-key',
})
